import { createDomain, fork, sample, Scope } from 'effector';
import { createGate } from 'effector-react';
import { signout } from '@features/common';
import { apiRequests } from '../api';
import { DataResponse, Option } from '../types/main';
import { RequestPayload } from '../types/request.payload';
import { getOptionsFromAreaList, getPayloadWithCancelSignal } from './helpers';

export const ControlDomain = createDomain();

export const ControlGate = createGate();

export const fxGetData = ControlDomain.createEffect<
  { payload: RequestPayload; signal: AbortController['signal'] },
  DataResponse,
  Error
>().use(apiRequests.getData);

export const startRequest = ControlDomain.createEvent<RequestPayload>();

export const setOptions = ControlDomain.createEvent<Option[] | null>();
export const $options = ControlDomain.createStore<Option[] | null>(null)
  .on(setOptions, (_, options) => {
    console.log('=====options', options);
    return options;
  })
  .reset(ControlGate.close, signout);

sample({
  clock: startRequest,
  fn: (payload) => getPayloadWithCancelSignal<RequestPayload>(payload),
  target: fxGetData,
});

sample({
  clock: fxGetData.doneData,
  fn: ({ areaList }) => getOptionsFromAreaList(areaList),
  target: $options,
});

export const scopes: { [key: string]: Scope } = {};

export const createScope = (name: string) => {
  if (scopes[name]) return scopes[name];
  scopes[name] = fork(ControlDomain);

  return scopes[name];
};
